import { RangeOptions } from 'experiences/Calculators/Utils/types'

type Input = 'debtAmount' | 'interestRate' | 'monthlyPayment'

export type InputState = {
	[x in Input]: number
}

export const debtCalcInputConfig: { [x in Input]: RangeOptions<InputState> } = {
	debtAmount: {
		title: 'Current Debt Amount',
		defaultValue: 10000,
		min: 1000,
		max: () => 50000,
		step: 1000,
		leadingChar: '$',
		trailingChar: 'k',
		isFullWidth: true,
		displayInThousands: true
	},
	interestRate: {
		title: 'Current Interest Rate (APR)',
		defaultValue: 20,
		min: 6,
		max: () => 35,
		step: 1,
		leadingChar: '',
		trailingChar: '%'
	},
	monthlyPayment: {
		title: 'Current Monthly Payment',
		defaultValue: 400,
		min: 0,
		max: (state: InputState): number => {
			const minTerm = 24
			const monthlyInterest = state.interestRate / 12
			const powMonthlyInterest = Math.pow(monthlyInterest + 1, minTerm)
			const monthlyPayment =
				(state.debtAmount * monthlyInterest * powMonthlyInterest) / (powMonthlyInterest - 1) / minTerm
			return Math.round(monthlyPayment / 100 + 1) * 100
		},
		step: 1,
		leadingChar: '$',
		trailingChar: ''
	}
}

export const CALCULATOR_INFORMATION_TOOLTIP_TEXT =
	'Calculate your estimated monthly payment for a debt consolidation loan by using this helpful tool. Adjust monthly payment, rate, and loan amount to get an idea of what you’ll save each month.'

export const CALCULATOR_ESTIMATE_TOOLTIP_TEXT =
	"This tool is for illustrative and educational purposes only. All rates, savings, and estimations are presented without guarantee and are subject to change pursuant to each provider's discretion and may not be available in all states or for all types.ts of loans. Carefully consider whether consolidating your existing debt is the right choice for you. Consolidating debts means you will have a single payment monthly, but it may not reduce or pay your debt off sooner. The payment reduction may come from a lower interest rate, a longer loan term, or a combination of both. By extending the loan term, you may pay more in interest over the life of the loan."

export const buildInitialState = (): InputState =>
	Object.entries(debtCalcInputConfig).reduce(
		(accum, [key, value]) => ({ [key]: value.defaultValue, ...accum }),
		{} as InputState
	)
